import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../config';

const ICONS = {
  send: 'M12 19l9 2-9-18-9 18 9-2zm0 0v-8',
  gift: 'M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7',
  invoice: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  split: 'M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4',
  lock: 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
  card: 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z',
  share: 'M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z',
  car: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
  pin: 'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z',
  store: 'M19 7h-3V5a3 3 0 00-3-3h-2a3 3 0 00-3 3v2H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2z',
  phone: 'M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z',
  video: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z',
};

const CATEGORY_COLORS = {
  transfer: 'bg-purple-50 hover:bg-purple-100 text-purple-700 border-purple-200',
  escrow: 'bg-amber-50 hover:bg-amber-100 text-amber-700 border-amber-200',
  giftcard: 'bg-pink-50 hover:bg-pink-100 text-pink-700 border-pink-200',
  share: 'bg-emerald-50 hover:bg-emerald-100 text-emerald-700 border-emerald-200',
  transport: 'bg-blue-50 hover:bg-blue-100 text-blue-700 border-blue-200',
  location: 'bg-cyan-50 hover:bg-cyan-100 text-cyan-700 border-cyan-200',
  marketplace: 'bg-orange-50 hover:bg-orange-100 text-orange-700 border-orange-200',
  communication: 'bg-gray-50 hover:bg-gray-100 text-gray-700 border-gray-200',
};

const CUALaccionMenu = ({
  open,
  onClose,
  recipientUserId,
  conversationId,
  onAction,        // (actionId) => void  — handled by parent (transfer/escrow/giftcard etc.)
  onStartCall,     // (type) => void
}) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState('');
  const [paymentCurrency, setPaymentCurrency] = useState('CUALCOIN');
  const [paymentConcept, setPaymentConcept] = useState('');
  const [submittingPayment, setSubmittingPayment] = useState(false);
  const [submittingLocation, setSubmittingLocation] = useState(false);

  useEffect(() => {
    if (!open || !recipientUserId) return;
    setLoading(true);
    setShowPaymentForm(false);
    axios
      .get(`${API}/messaging/cualaccion/${recipientUserId}`)
      .then((res) => setData(res.data))
      .catch((e) => {
        console.error('cualaccion error:', e);
        setData(null);
      })
      .finally(() => setLoading(false));
  }, [open, recipientUserId]);

  if (!open) return null;

  const handleClick = async (action) => {
    if (!action.available) return;

    if (action.id === 'voice_call' || action.id === 'video_call') {
      onClose();
      onStartCall && onStartCall(action.id === 'video_call' ? 'video' : 'voice');
      return;
    }

    if (action.id === 'request_payment') {
      setShowPaymentForm(true);
      return;
    }

    if (action.id === 'share_location') {
      if (!navigator.geolocation) {
        alert('Tu navegador no permite compartir ubicacion.');
        return;
      }
      setSubmittingLocation(true);
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          try {
            await axios.post(`${API}/messaging/cualaccion/share-location`, {
              conversation_id: conversationId,
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
              label: 'Mi ubicacion actual',
            });
            onClose();
          } catch (e) {
            alert(e.response?.data?.detail || 'Error compartiendo ubicacion');
          } finally {
            setSubmittingLocation(false);
          }
        },
        (err) => {
          setSubmittingLocation(false);
          alert('No se pudo obtener ubicacion: ' + err.message);
        },
        { enableHighAccuracy: false, timeout: 10000 },
      );
      return;
    }

    // Delegate to parent handler (transfer, escrow, giftcard, share, transport, marketplace)
    onClose();
    onAction && onAction(action.id, action);
  };

  const submitRequestPayment = async () => {
    const amount = parseFloat(paymentAmount);
    if (!amount || amount <= 0) {
      alert('Monto invalido');
      return;
    }
    setSubmittingPayment(true);
    try {
      await axios.post(`${API}/messaging/cualaccion/request-payment`, {
        conversation_id: conversationId,
        amount,
        currency: paymentCurrency,
        concept: paymentConcept,
      });
      setPaymentAmount('');
      setPaymentConcept('');
      setShowPaymentForm(false);
      onClose();
    } catch (e) {
      alert(e.response?.data?.detail || 'Error enviando solicitud');
    } finally {
      setSubmittingPayment(false);
    }
  };

  return (
    <div
      className="absolute inset-0 z-30 bg-black/40 flex items-end sm:items-center justify-center p-2 sm:p-6"
      data-testid="cualaccion-overlay"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        data-testid="cualaccion-menu"
      >
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-purple-600 to-pink-500 text-white px-5 py-3 rounded-t-2xl flex items-center justify-between">
          <div>
            <h3 className="font-bold text-base">CUALacción</h3>
            <p className="text-xs text-white/80">
              {data?.recipient?.name ? `Acciones sobre ${data.recipient.name}` : 'Catalogo contextual'}
            </p>
          </div>
          <button
            onClick={onClose}
            data-testid="cualaccion-close"
            className="w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="p-4">
          {loading && <p className="text-center text-sm text-gray-500 py-6">Cargando catalogo...</p>}

          {!loading && data && (
            <>
              {/* Balances */}
              <div className="bg-gray-50 rounded-lg p-3 mb-4 grid grid-cols-2 gap-3">
                <div>
                  <p className="text-xs text-gray-500">Tu saldo Cc</p>
                  <p className="font-bold text-gray-800">{data.actor_balances.cualcoin.toFixed(2)}</p>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Tu saldo PV</p>
                  <p className="font-bold text-gray-800">{data.actor_balances.puntos_verdes.toFixed(2)}</p>
                </div>
                {!data.recipient.has_wen && (
                  <div className="col-span-2 bg-amber-50 border border-amber-200 rounded p-2 text-xs text-amber-700">
                    Este usuario aun no tiene WEN activo. Considera enviarle una <b>CUALgiftcard</b> para activarlo.
                  </div>
                )}
              </div>

              {/* Request Payment Form */}
              {showPaymentForm && (
                <div className="bg-purple-50 rounded-lg p-3 mb-4 space-y-2 border border-purple-200" data-testid="payment-form">
                  <p className="text-sm font-semibold text-purple-800">Solicitar pago</p>
                  <div className="flex gap-2">
                    <input
                      type="number"
                      value={paymentAmount}
                      onChange={(e) => setPaymentAmount(e.target.value)}
                      placeholder="Monto"
                      data-testid="payment-amount"
                      className="flex-1 px-3 py-2 border border-gray-300 rounded text-sm"
                    />
                    <select
                      value={paymentCurrency}
                      onChange={(e) => setPaymentCurrency(e.target.value)}
                      data-testid="payment-currency"
                      className="px-3 py-2 border border-gray-300 rounded text-sm"
                    >
                      <option value="CUALCOIN">Cc</option>
                      <option value="PUNTOS_VERDES">PV</option>
                    </select>
                  </div>
                  <input
                    type="text"
                    value={paymentConcept}
                    onChange={(e) => setPaymentConcept(e.target.value)}
                    placeholder="Concepto (ej. cena del viernes)"
                    data-testid="payment-concept"
                    className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
                  />
                  <div className="flex gap-2">
                    <button
                      onClick={() => setShowPaymentForm(false)}
                      className="flex-1 py-2 bg-gray-200 hover:bg-gray-300 rounded text-sm"
                    >
                      Cancelar
                    </button>
                    <button
                      onClick={submitRequestPayment}
                      disabled={submittingPayment}
                      data-testid="payment-submit"
                      className="flex-1 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded text-sm disabled:opacity-50"
                    >
                      {submittingPayment ? 'Enviando...' : 'Enviar solicitud'}
                    </button>
                  </div>
                </div>
              )}

              {/* Actions Grid */}
              {!showPaymentForm && (
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                  {data.actions.map((action) => (
                    <button
                      key={action.id}
                      onClick={() => handleClick(action)}
                      disabled={!action.available || submittingLocation}
                      data-testid={`cualaccion-action-${action.id}`}
                      className={`text-left rounded-xl border p-3 transition-all ${
                        action.available
                          ? CATEGORY_COLORS[action.category] || 'bg-gray-50 hover:bg-gray-100 border-gray-200 text-gray-700'
                          : 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed'
                      }`}
                    >
                      <svg className="w-5 h-5 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d={ICONS[action.icon] || ICONS.send} />
                      </svg>
                      <p className="font-semibold text-sm leading-tight">{action.label}</p>
                      <p className="text-xs mt-1 opacity-70 leading-tight">{action.description}</p>
                    </button>
                  ))}
                </div>
              )}

              <p className="text-[10px] text-gray-400 text-center mt-4">
                CUALacción - Hub Contextual de CUALAPP
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CUALaccionMenu;
